import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';

export interface ButtonI {
  disabled?: boolean;
  label?: string;
  kind?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'square' | 'primary-ghost' | 'secondary-ghost' | 'danger-ghost';
  size?: 'small' | 'medium' | 'large';
}

@Component({
  selector: 'analysis-buttons',
  template: `<button
    #buttonElement
    (click)="clickButton()"
    [ngClass]="'btn'"
    [ngStyle]="{ 'background-color': backgroundColor }"
    analysisBtn
    [disabledButton]="disabled"
    [kindButton]="kind"
    [sizeButton]="size"
    [attr.data-test]="id"
  ><fa-icon *ngIf="isLoading" [icon]="['fas', 'circle-notch']" [spin]="isLoading"></fa-icon>
    {{ label }}
  </button>`,
  styleUrls: ['./buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonsComponent {
  @ViewChild('buttonElement') buttonElement: ElementRef;
  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();
  @Input() backgroundColor?: string;

  @Input() disabled?: boolean = false;
  @Input() label?: string;
  @Input() kind?: ButtonI['kind'];
  @Input() size?: ButtonI['size'];
  @Input() id?: string;
  @Input() isLoading? = false;

  constructor(library: FaIconLibrary) {
    library.addIcons(faCircleNotch);
  }

  clickButton(): void {
    this.clicked.emit();
  }
}
